import React from 'react';
import ProductPriceFormat from '../../../../products/product-price/product-price-format';
import { useAppSelector } from '../../data/store';
import Step1ProceedToCheckoutBtn from './step-1-proceed-to-checkout-btn';

const Step1MobileHeader = () => {

    const cartData = useAppSelector(store => store.root.cartData);
    const priceData = cartData.priceData;

    return (
        <div className="flex md:hidden items-center mb-4">
            <div className="flex-1">
                <h1 className="text-3xl font-bold">Cart</h1>

                <div className="text-tiny text-gray-700 inline-flex items-center justify-between">
                    <span className="mr-2">Order Total</span>
                    <span className="ml-2"><ProductPriceFormat price={ priceData.totalPrice } /></span>
                </div>
            </div>

            <div>
                <Step1ProceedToCheckoutBtn classes="w-btn font-normal py-3 whitespace-nowrap" />
            </div>
        </div>
    )
};

export default Step1MobileHeader;